export const  translationMenuManagement = (props) => {
  return {
    title: props.t("menu.label.fastfood.menu.management.title"),
    create: props.t("label.actions.create"),
    save: props.t("config-ifood.modal.save"),
    edit: props.t("label.actions.edit"),
    subtitle: props.t("menu.label.fastfood.menu.management.subtitle"),
    spinner: props.t("menu.label.fastfood.menu.management.spinner"),
    placeholder: props.t(
      "menu.label.fastfood.menu.management.company.placeholder"
    ),
    error: props.t("menu.label.fastfood.menu.management.company.error"),
    description: props.t(
      "menu.label.fastfood.menu.management.company.description"
    ),
    companyCreate: props.t(
      "menu.label.fastfood.menu.management.company.create"
    ),
    notFound: props.t("menu.label.fastfood.menu.management.company.notFound"),
    select: props.t("menu.label.fastfood.menu.management.company.select"),
    modalTitle: props.t(
      "menu.label.fastfood.menu.management.company.modal.title"
    ),
    modalMessage: props.t(
      "menu.label.fastfood.menu.management.company.modal.message"
    ),
    modalWarning: props.t(
      "menu.label.fastfood.menu.management.company.modal.warning"
    ),
    modalConfirmButton: props.t(
      "menu.label.fastfood.menu.management.company.modal.button.yes"
    ),
    modalCancelButton: props.t(
      "menu.label.fastfood.menu.management.company.modal.button.cancel"
    ),
    confirmDelete: props.t(
      "menu.label.fastfood.menu.management.company.modal.dialog.confirmDelete"
    ),
    dialogError: props.t(
      "menu.label.fastfood.menu.management.company.modal.dialog.error"
    ),
    confirmSuccess: props.t(
      "menu.label.fastfood.menu.management.company.modal.dialog.confirmSuccess"
    ),
    saveError: props.t("menu.label.fastfood.menu.management.company.modal.dialog.save.error"),
    menuAdd: props.t("menu.label.fastfood.menu.management.menu.add"),
    groupsAddTitle: props.t("menu.label.fastfood.menu.management.group.add.title"),
    groupsAddButton: props.t("menu.label.fastfood.menu.management.group.add.button"),
    groupsSearch: props.t("menu.label.fastfood.menu.management.group.add.search"),
    groupsAllAdded: props.t("menu.label.fastfood.menu.management.group.add.allAdded"),
    groupsLoadError: props.t("menu.label.fastfood.menu.management.group.add.loadError"),
    groupsCode: props.t("menu.label.fastfood.menu.management.group.add.code"),
    groupsDescription: props.t("menu.label.fastfood.menu.management.group.add.description"),
    groupsSelectAll: props.t("menu.label.fastfood.menu.management.group.add.selectAll"),
    groupLinked: props.t("menu.label.fastfood.menu.management.group.linked"),
    moveUp: props.t("menu.label.fastfood.menu.management.move.up"),
    moveDown: props.t("menu.label.fastfood.menu.management.move.down"),
    moveSuccess: props.t("menu.label.fastfood.menu.management.move.success"),
    moveError: props.t("menu.label.fastfood.menu.management.move.error")
  }
}